import API, { API_URL } from "api/API";
import { ApiResult } from "libs/types";

interface GetObsDatetimeApiResult extends ApiResult {
  obs_datetime: {
    [id: string]: string;
  }
}

async function getObsDatetimeApi():Promise<GetObsDatetimeApiResult> {
  const {data} = await API.get(`${API_URL.FORECAST.GET_OBS_DATETIME}`);

  return data;
}

export default getObsDatetimeApi;